import React, { useState, useEffect } from 'react';
import Utils from 'utilities/helper.util';
import { Tag } from 'carbon-components-react';

export const Reference: React.FC<any> = (props: any) => {
  const { originalEnquiry } = props;
  const [enquiry, setEnquiry] = useState<any>();

  useEffect(() => {
    if (originalEnquiry && !Utils.isObjectEmpty(originalEnquiry)) {
      setEnquiry(originalEnquiry);
    }
  }, [originalEnquiry]);

  const isSandboxTestTag = () => <Tag type="purple">Sandbox</Tag>;

  return (
    <>
      {enquiry && (
        <div className="reference-section">
          <div className="reference-section--content">
            <p>My reference</p>
            <p>{enquiry.userReference}</p>
          </div>
          <div className="reference-section--content">
            <p>Job site</p>
            <p>{Utils.getFullAddress(enquiry.Address)}</p>
          </div>
          <div className="reference-section--content">
            <p>Enquiry Date</p>
            <p>{Utils.toLocalDateTimeFormat(enquiry.createdAt)}</p>
          </div>
          {enquiry.isSandboxTest && (
            <div className="sandbox-tag">{isSandboxTestTag()}</div>
          )}
        </div>
      )}
      <hr className="section--divider" />
    </>
  );
};

Reference.displayName = 'Reference';
export default Reference;
